import { servicesData } from '@/mocks/homeData';
import { SectionTag, SectionTitle, SectionDescription, IconCard } from '@/components/base/Card';

export default function ServicesSection() {
  return (
    <section className="section-padding bg-background-100">
      <div className="container-custom">
        <div className="text-center mb-14">
          <SectionTag>核心服务</SectionTag>
          <SectionTitle>全方位高端资源整合</SectionTitle>
          <SectionDescription>
            豪门国际为您提供覆盖全球的高端资源整合服务，从豪门资源对接到精英教育规划，一站式满足您的多元化需求。
          </SectionDescription>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {servicesData.map((service) => (
            <IconCard
              key={service.id}
              icon={service.icon}
              title={service.title}
              description={service.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
}